<div class="baseline-intro-content-container" *ngIf="config.content">
  <img src="/assets/baseline-cq-intro.svg" />
  <h2>Get ready for your first session</h2>
  <p>{{ staticIntroContent }}</p>
  <div class="multiple-choice">
    <iris-icon name="list" [size]="irisIconSizes.SM"/>
    <span>Multiple choice</span>
  </div>
</div>
<div class="baseline-intro-content-footer">
  <iris-icon name="sparkles" [size]="irisIconSizes.SM" colorToken="$color-dec-yellow-100" />
  <span>{{infoText}}</span>
</div>